(function () {
  'use strict';

  /* ================================
     WAX COLORS TIER CONFIG
     Edit these values later if needed.
     Shopify automatic discounts remain the source of truth.
     ================================ */
  var CONFIG = {
    productType: '100% Viscose Stoles',
    unitPrice: 1799,
    tiers: {
      1: { total: 1799 },
      2: { total: 3199 },
      3: { total: 4299 },
      4: { total: 6098 },
      5: { total: 7000, perUnit: 1400 }
    }
  };

  var SYNC_DELAY = 180;
  var syncTimer = null;
  var addingVariant = {};
  var bound = false;

  function money(amount) {
    return '₹' + Math.round(Number(amount) || 0).toLocaleString('en-IN');
  }

  function expectedTotal(count) {
    count = Math.max(0, Math.floor(Number(count) || 0));
    if (!count) return 0;
    if (count <= 5) return CONFIG.tiers[count].total;
    return count * CONFIG.tiers[5].perUnit;
  }

  function countStoles(cart) {
    var count = 0;
    (cart && cart.items || []).forEach(function (item) {
      if (item.product_type === CONFIG.productType) {
        count += Number(item.quantity) || 0;
      }
    });
    return count;
  }

  function cartProductIds(cart) {
    var ids = {};
    (cart && cart.items || []).forEach(function (item) {
      if (item.product_type === CONFIG.productType && item.product_id != null) {
        ids[String(item.product_id)] = true;
      }
    });
    return ids;
  }

  function elements() {
    var root = document.querySelector('[data-wax-cart-upgrade]');
    if (!root) return null;
    return {
      root: root,
      messageWrap: root.querySelector('[data-wax-message-wrap]'),
      main: root.querySelector('[data-wax-message-main]'),
      small: root.querySelector('[data-wax-message-small]'),
      progressWrap: root.querySelector('[data-wax-progress-wrap]'),
      progressFill: root.querySelector('[data-wax-progress-fill]'),
      progressTrack: root.querySelector('[role="progressbar"]'),
      complete: root.querySelector('[data-wax-complete]'),
      candidates: root.querySelectorAll('[data-wax-candidate]')
    };
  }

  function isINR() {
    return !!(window.Shopify && Shopify.currency && Shopify.currency.active === 'INR');
  }

  function renderMessage(count, els) {
    var main = '';
    var small = '';

    if (count === 1) {
      main = 'Add 2 more for ' + money(expectedTotal(3) - expectedTotal(1)) + ' — get any three for ' + money(expectedTotal(3));
      small = 'or add 1 more for just ' + money(expectedTotal(2) - expectedTotal(1));
    } else if (count === 2) {
      main = 'Add a third for just ' + money(expectedTotal(3) - expectedTotal(2)) + ' — complete your WAX 3 Edit';
    } else if (count === 3) {
      main = '✓ WAX 3 Edit unlocked — you\'re saving ' + money((CONFIG.unitPrice * 3) - expectedTotal(3));
      small = 'Add 2 more for ' + money(expectedTotal(5) - expectedTotal(3)) + ' — get 5 for ' + money(expectedTotal(5));
    } else if (count === 4) {
      main = 'Add 1 more — your 5th stole is just ' + money(expectedTotal(5) - expectedTotal(4));
    } else if (count >= 5) {
      main = '✓ Best price unlocked — ' + money(CONFIG.tiers[5].perUnit) + ' a stole, saving ' + money(CONFIG.unitPrice - CONFIG.tiers[5].perUnit) + ' on each';
    }

    els.main.textContent = main;
    els.small.textContent = small;
    els.main.hidden = !main;
    els.small.hidden = !small;
    els.messageWrap.hidden = !main;
  }

  function renderProgress(count, els) {
    var capped = Math.min(count, 5);
    var visible = count > 0;
    els.progressWrap.hidden = !visible;
    els.progressFill.style.width = ((capped / 5) * 100) + '%';
    els.progressTrack.setAttribute('aria-valuenow', String(capped));

    [2, 3, 5].forEach(function (marker) {
      var el = els.root.querySelector('[data-wax-progress-marker="' + marker + '"]');
      if (!el) return;
      el.classList.toggle('is-reached', count >= marker);
    });
  }

  function renderCandidates(cart, els) {
    if (!els || !els.complete) return;
    var inCart = cartProductIds(cart);
    var visibleCount = 0;

    Array.prototype.forEach.call(els.candidates, function (candidate) {
      var productId = String(candidate.getAttribute('data-product-id') || '');
      var excluded = !!inCart[productId];
      var addButton = candidate.querySelector('[data-wax-candidate-add]');

      candidate.hidden = excluded;
      candidate.classList.toggle('is-in-cart', false);
      if (addButton) {
        addButton.disabled = !!addingVariant[String(addButton.getAttribute('data-variant-id'))];
      }
      if (!excluded) visibleCount += 1;
    });

    els.complete.hidden = countStoles(cart) === 0 || visibleCount === 0;
  }

  function render(cart) {
    var els = elements();
    if (!els) return;

    var count = countStoles(cart);
    var inr = isINR();
    var currencyNote = document.querySelector('[data-wax-currency-note]');

    els.root.dataset.stoleCount = String(count);
    els.root.hidden = !inr || count === 0;

    if (currencyNote) currencyNote.hidden = inr;

    if (!inr || count === 0) return;

    renderMessage(count, els);
    renderProgress(count, els);
    renderCandidates(cart, els);
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function refreshDrawerFromCart(cart) {
    if (window.theme && theme.cartDrawer && typeof theme.cartDrawer.buildCart === 'function') {
      theme.cartDrawer.buildCart(cart, false);
      return;
    }
    try {
      document.dispatchEvent(new CustomEvent('waxcolors:cart-synced', { detail: cart }));
    } catch (e) {}
  }

  function syncFromCart() {
    return getCart().then(function (cart) {
      render(cart);
      return cart;
    }).catch(function () {});
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncFromCart, SYNC_DELAY);
  }

  function addCandidate(button) {
    var id = button.getAttribute('data-variant-id');
    if (!id || addingVariant[id]) return;

    addingVariant[id] = true;
    renderCandidatesFromCurrentCart();

    var body = 'id=' + encodeURIComponent(id) + '&quantity=1';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      body: body
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add product');
      return response.json();
    }).then(function () {
      return getCart();
    }).then(function (cart) {
      delete addingVariant[id];
      refreshDrawerFromCart(cart);
      render(cart);
    }).catch(function () {
      delete addingVariant[id];
      scheduleSync();
    });
  }

  function renderCandidatesFromCurrentCart() {
    getCart().then(function (cart) {
      var els = elements();
      if (els && isINR()) renderCandidates(cart, els);
    }).catch(function () {});
  }

  function handleClick(event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-wax-candidate-add]') : null;
    var giftToggle = target && target.closest ? target.closest('[data-wax-gift-note-toggle]') : null;

    if (button) {
      if (!document.querySelector('[data-wax-cart-upgrade]')) return;
      event.preventDefault();
      event.stopPropagation();
      addCandidate(button);
      return;
    }

    if (giftToggle) {
      event.preventDefault();
      var box = document.querySelector('[data-wax-gift-note-box]');
      if (!box) return;
      var expanded = giftToggle.getAttribute('aria-expanded') === 'true';
      giftToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      box.hidden = expanded;
      if (!expanded) {
        var textarea = box.querySelector('textarea');
        if (textarea) textarea.focus();
      }
    }
  }

  function handleCartSynced(event) {
    if (event && event.detail) render(event.detail);
    else scheduleSync();
  }

  function bind() {
    if (bound) return;
    bound = true;

    document.addEventListener('click', handleClick, true);
    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('#CartDrawer .js-qty__num')) scheduleSync();
    }, true);
    document.addEventListener('waxcolors:cart-synced', handleCartSynced);

    if (window.jQuery) {
      jQuery('body').on('updateCart.ajaxcart.waxTiered', scheduleSync);
      jQuery('body').on('added.ajaxProduct.waxTiered', scheduleSync);
      jQuery('body').on('drawerOpen.CartDrawer.waxTiered', scheduleSync);
    }

    syncFromCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
